/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} My_Grower_Report_Period_MonthInputs */

const vi_my_grower_report_period_month = /** @type {(inputs: My_Grower_Report_Period_MonthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tháng`)
};

/**

* @param {My_Grower_Report_Period_MonthInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const my_grower_report_period_month = /** @type {((inputs?: My_Grower_Report_Period_MonthInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<My_Grower_Report_Period_MonthInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_my_grower_report_period_month(inputs)
});